module.exports = __webpack_public_path__ + "img/chris.6fa5ad49.jpg";